import i18next from "i18next";
import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { useReduxState } from "Shared/redux/useReduxState";
import { MyBookingSubwidget, MyBookingWidget } from "./KenticoKontent";

export interface Props {
	culture: string;
}

export const useMyBooking = () => {
	const [kontent] = useReduxState("kontent.myBooking.myBookingTest.contents");

	const widgetTemplate = (widget: MyBookingWidget) => html`
		<div
			class="flex flex-col items-center justify-center gap-2 rounded-xl border border-solid border-[#E0E0E0] bg-white p-4 shadow-sm"
		>
			<div class="flex h-9 w-9 items-center justify-center rounded-md bg-n-cyan text-xl/none text-white">
				${unsafeHTML(widget.icon.value)}
			</div>
			<div class="flex flex-col justify-center gap-1">
				<div class="text-xl font-bold text-n-blue">${unsafeHTML(widget.title.value)}</div>
				<div class="text-sm">${unsafeHTML(widget.text.value)}</div>
			</div>
			<div
				class="flex w-full cursor-pointer items-center justify-center gap-2 border-t border-solid border-[#E0E0E0] pt-4 text-lg font-medium text-n-cyan hover:text-n-blue"
				@click=${() => (window.location.href = widget.url.value)}
			>
				<span>${unsafeHTML(widget.button.value)}</span>
				<div class="h-[10px] w-[10px] rotate-45 transform border-r-2 border-t-2 border-solid"></div>
			</div>
		</div>
	`;

	const subWidgetTemplate = (widget: MyBookingSubwidget) => html`
		<div class="flex flex-col gap-4 p-4">
			<div class="flex items-center gap-2">
				<div
					class="flex h-11 w-11 items-center justify-center rounded-full bg-[#F0F3F7] text-base/none text-n-blue"
				>
					${unsafeHTML(widget.icon.value)}
				</div>
				<div class="text-n-blue">${unsafeHTML(widget.title.value)}</div>
			</div>
			<div class="text-left text-xs">${unsafeHTML(widget.text.value)}</div>
			<div
				class="cursor-pointer text-left text-n-cyan underline underline-offset-4 hover:text-n-blue"
				@click=${() => (window.location.href = widget.url.value)}
			>
				${unsafeHTML(widget.linktext.value)}
			</div>
		</div>
	`;

	const htmlTemplate = () =>
		kontent
			? html`
					<div class="container flex flex-col items-center gap-6 p-6">
						<div class="w-full text-left font-emphasis text-xl text-n-blue">
							${i18next.t("Administra tu reserva")}
						</div>
						<div
							class="inline-grid gap-8"
							style=${`grid-template-columns: repeat(${kontent.widget.length}, minmax(0, 1fr))`}
						>
							${kontent.widget.map(widgetTemplate)}
						</div>
						<div
							class="inline-grid gap-8"
							style=${`grid-template-columns: repeat(${kontent.subwidget.length}, minmax(0, 1fr))`}
						>
							${kontent.subwidget.map(subWidgetTemplate)}
						</div>
					</div>
			  `
			: "";

	return { htmlTemplate };
};
